import {
  Component,
  ViewChild,
  OnInit
} from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'cockehsu-loader',
  template: '<div #loader></div>',
  styles: [`
div {
  width: 100%;
  height: 100%;
  background: transparent url("/assets/subtle_dots.png") repeat;
}
`],
})
export class CockehsuLoaderComponent implements OnInit {

  @ViewChild('loader')
  private loader;

  private currentProgress: number;

  private vis;
  private text;
  private bgArcs;
  private arcs;
  private arcsParams: ArcsParams;
  private color: string;
  private endAngle: number;

  constructor() {
    this.arcsParams = {
      radius: 90,
      num: 4,
      bgcolor: '#eee',
      color: '#e41b13',
      thickness: 8,
      gap: 10,
      endAngle: Math.PI,
    };
  }

  ngOnInit() {
    let ne = this.loader.nativeElement;
    const w = ne.clientWidth;
    const h = ne.clientHeight;
    this.vis = d3.select(ne)
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      .append('g')
      .attr('transform', `translate(${w/2}, ${h/2})`);

    this.bgArcs = [];
    this.arcs = [];
    this.currentProgress = 0;

    for (let i = 0; i < this.arcsParams.num; i++) {
      const r = Math.random()*this.arcsParams.num;
      const angle = this.arcsParams.endAngle*r + this.arcsParams.endAngle*r/this.arcsParams.num;
      this.bgArcs.push({
          outerRadius: this.arcsParams.radius - i*this.arcsParams.gap,
          innerRadius: this.arcsParams.radius - i*this.arcsParams.gap - this.arcsParams.thickness,
          startAngle: angle,
          endAngle: angle+this.arcsParams.endAngle,
          padAngle: 0,
      });
      this.arcs.push({
          outerRadius: this.arcsParams.radius - i*this.arcsParams.gap,
          innerRadius: this.arcsParams.radius - i*this.arcsParams.gap - this.arcsParams.thickness,
          startAngle: angle,
          endAngle: angle,
          padAngle: 0,
      });

    }

    this.text = this.vis.append('text')
      .attr('text-anchor', 'middle')
      .attr('font-size', `${1.5*this.arcsParams.radius/this.arcsParams.num}px`)
      .attr('dy', `${0.5*this.arcsParams.radius/this.arcsParams.num}px`)
      .attr('fill', this.arcsParams.color)
      .text('0 %');

    this.vis.selectAll('path').data(this.bgArcs)
      .enter()
      .append('path')
      .attr('d', (d) => d3.arc()(d))
      .style('fill', this.arcsParams.bgcolor);

    this.vis.selectAll('path.arcs').data(this.arcs)
      .enter()
      .append('path')
      .classed('arcs', true)
      .attr('d', (d) => d3.arc()(d))
      .style('fill', this.arcsParams.color);
  }

  updateProgress(n: number) {
    const ln = this.currentProgress;
    this.currentProgress = n;
    this.vis.selectAll('path.arcs')
      .style('fill', this.arcsParams.color)
      .interrupt()
      .transition()
      .duration(100)
      .ease(d3.easeCubicOut)
      .attrTween('d', (d) => {
    	return this.arcTween(d, n*this.arcsParams.endAngle)(d);
      });

    let fmt = d3.format('.0f');
    this.text
      .text(fmt(100*ln) + ' %')
      .interrupt()
      .transition()
      .duration(100)
      .ease(d3.easeLinear)
      .tween('text', function() {
	const text = this;
	let interpolateText = d3.interpolateNumber(ln, n);
	return function(t) {
	  text.textContent = fmt(interpolateText(t)*100) + ' %';
	};
      });
  }

  arcTween(arc: any, offsetAngle: number) {
    return function(d) {
      let interpolate = d3.interpolate(d.endAngle, d.startAngle + offsetAngle);
      return function(t) {
        d.endAngle = interpolate(t);
        return d3.arc()(d);
      };
    };
  }

}

interface ArcsParams {
  radius: number;
  num: number;
  bgcolor: string;
  color: string;
  thickness: number;
  gap: number;
  endAngle: number;
}



// WEBPACK FOOTER //
// ./src/app/cockehsu-loader.component.ts